<div class="event-page" [class.is-totem]="viewTotem">
  <div *ngIf="!event || loading; else divEvent" class="container-lottie">
    <div class="loading-container">
      <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
        containerClass="loading-box"></ng-lottie>
    </div>
  </div>

  <ng-template #divEvent>
    <!--
      Una sola rejilla para toda la página. Las columnas de sangrado
      (bleed-start / bleed-end) son las que dejan que la banda ciruela y el
      cartel lleguen al borde de la pantalla sin recurrir a 100vw, y la
      columna del aside abarca las dos filas, así que la tarjeta de compra
      puede quedarse pegada con position: sticky sin medir nada en JavaScript.
    -->
    <div class="event-layout">
      <!-- El escenario: la banda oscura que hay detrás del cartel y del título -->
      <div class="stage" aria-hidden="true"></div>

      <!-- El cartel. En móvil va a sangre y es lo primero que se ve -->
      <div class="hero-poster">
        <img class="poster-img" [src]="imageUrl" [alt]="event.title" fetchpriority="high"
          (error)="imageUrl = 'assets/img/image_default.png'" />
        <span class="poster-tag pill-state" *ngIf="heroTag" [ngClass]="heroTag.class">
          <i class="fal {{ heroTag.icon }}"></i>{{ heroTag.text }}
        </span>
        <div class="poster-actions" *ngIf="event.publish && !viewTotem">
          <button type="button" class="poster-action" *ngIf="(profile|async)" (click)="editFavorito()"
            [attr.aria-label]="isWishlist ? 'Quitar de favoritos' : 'Guardar en favoritos'"
            [attr.aria-pressed]="isWishlist">
            <i class="fa-heart" [class]="isWishlist ? 'fa-solid is-on' : 'fa-light'"></i>
          </button>
          <button type="button" class="poster-action" *ngIf="sharedSupported" (click)="shareEvent()"
            aria-label="Compartir este evento">
            <i class="fa-light fa-arrow-up-from-bracket"></i>
          </button>
        </div>
      </div>

      <!-- El título y los cuatro datos que se buscan primero -->
      <div class="hero-info">
        <div class="hero-notice" *ngIf="!event.publish && !hasSpecialEventState()">
          <i class="fa-light fa-circle-exclamation"></i>
          <span>Evento desactivado</span>
        </div>

        <div class="hero-title-row">
          <h1 class="hero-title">{{ event.title }}</h1>
          <span *ngIf="adminCitylok || isLite" class="hero-menu-trigger" [matMenuTriggerFor]="eventActionsMenu"
            aria-label="Acciones del evento">
            <i class="fa-light fa-ellipsis-vertical fa-lg"></i>
          </span>
          <mat-menu #eventActionsMenu="matMenu" xPosition="before" panelClass="menuContentCustom">
            <button mat-menu-item [routerLink]="['/event/edit/'+slug]" *ngIf="adminCitylok || isLite">
              <i class="fa-light fa-edit"></i> Editar
            </button>
          </mat-menu>
        </div>

        <div class="hero-meta">
          <p class="meta-row" *ngIf="getDateString()">
            <i class="fa-light fa-calendar"></i>
            <span>{{ getDateString() }}</span>
          </p>
          <p class="meta-row" *ngIf="venueName || venueAddress">
            <i class="fa-light fa-location-dot"></i>
            <span><b *ngIf="venueName">{{ venueName }}</b><span *ngIf="venueName && venueAddress"> · </span>{{
              venueAddress }}</span>
          </p>
        </div>

        <!-- Las próximas funciones, para que el cartel no sea lo único que
             ocupa el encabezado cuando el evento se repite. Cada una abre el
             selector en su día; sin venta posible (Próximamente, aforo
             completo...) se quedan como dato y no abren nada -->
        <div class="hero-dates" *ngIf="upcomingDates.length && event.publish && !pastEvent">
          <button type="button" class="date-card" *ngFor="let day of upcomingDates"
            [disabled]="!datesOpenPicker" (click)="openDatePicker(day.session)">
            <span class="date-dow">{{ day.date | date:'EEE':'+0000' }}</span>
            <span class="date-day">{{ day.date | date:'d':'+0000' }}</span>
            <span class="date-month">{{ day.date | date:'MMM':'+0000' }}</span>
            <span class="date-hours">{{ day.hours.join(' · ') }}</span>
          </button>
          <button type="button" class="date-card date-card-more" *ngIf="moreDatesCount > 0"
            [disabled]="!datesOpenPicker" (click)="openDatePicker()">
            <span class="date-more-count">+{{ moreDatesCount }}</span>
            <span class="date-more-label">fechas</span>
          </button>
        </div>

        <div class="hero-pills" *ngIf="event.categories?.length">
          <span class="pill" *ngFor="let cat of event.categories">
            <i class="fal {{ cat.icon }}"></i>{{ cat.name }}
          </span>
        </div>

        <div class="hero-links" *ngIf="(owner?.id != 1 && createdBy) || (event.space && !viewTotem)">
          <div class="link-chip" *ngIf="owner?.id != 1 && createdBy && !viewTotem"
            [routerLink]="['/events', (createdBy?.slug)]">
            <i class="fa-light fa-buildings link-chip-icon"></i>
            <span class="link-chip-label">Organiza</span>
            <span class="link-chip-value">{{ createdBy?.name }}</span>
            <i class="fa-light fa-chevron-right link-chip-chevron"></i>
          </div>
          <div class="link-chip link-chip-static" *ngIf="owner?.id != 1 && createdBy && viewTotem">
            <i class="fa-light fa-buildings link-chip-icon"></i>
            <span class="link-chip-label">Organiza</span>
            <span class="link-chip-value">{{ createdBy?.name }}</span>
          </div>
          <div class="link-chip" *ngIf="event.space && !viewTotem" [routerLink]="['/venue',(event.space?.slug)]">
            <i class="fa-light fa-location-dot link-chip-icon"></i>
            <span class="link-chip-label">Espacio</span>
            <span class="link-chip-value">{{ event.space?.name }}</span>
            <i class="fa-light fa-chevron-right link-chip-chevron"></i>
          </div>
        </div>

        <!-- Miembros del espacio -->
        <div class="member-note" *ngIf="event?.space?.allow_subscription && !isMember">
          <span>
            ¿Quieres ser miembro de
            <span class="member-name">
              {{ event.space?.membership_title ? event.space?.membership_title : event.space?.name }}
            </span>?
          </span>
          <button type="button" class="member-link" (click)="openNewSubscriber()">
            Apúntate <i class="fas fa-arrow-pointer"></i>
          </button>
        </div>
        <div class="member-note" *ngIf="isMember">
          <span>Eres miembro de
            <span class="member-name">{{ event.space?.membership_title ? event.space?.membership_title :
              event.space?.name }}</span>
          </span>
        </div>

        <!-- En escritorio los dos iconos viven aquí; en móvil, sobre el cartel -->
        <div class="hero-actions" *ngIf="event.publish && !viewTotem">
          <button type="button" class="hero-action" *ngIf="(profile|async)" (click)="editFavorito()"
            [attr.aria-label]="isWishlist ? 'Quitar de favoritos' : 'Guardar en favoritos'"
            [attr.aria-pressed]="isWishlist">
            <i class="fa-heart" [class]="isWishlist ? 'fa-solid is-on' : 'fa-light'"></i>
          </button>
          <button type="button" class="hero-action" *ngIf="sharedSupported" (click)="shareEvent()"
            aria-label="Compartir este evento">
            <i class="fa-light fa-arrow-up-from-bracket"></i>
          </button>
        </div>
      </div>

      <!-- La compra. Tarjeta pegada en escritorio, barra fija abajo en móvil -->
      <div class="event-aside" *ngIf="event.publish">
        <div class="buy-slot" *ngIf="event.only_tpv_sales || !openExternal || viewTotem; else divHoursDates">
          <app-open-external [event]="event" [pastEvent]="pastEvent" [repeat]="repeatEvent"
            [openingMap]="openingDirectMap" (openHours)="openHoursEvent($event)"
            (openMap)="openMapDirectly($event)"></app-open-external>
          <!-- Evento de una sola sesión: el mapa se abre desde la tarjeta, sin
               pasar por el calendario. Lo lanza el propio selector, oculto, para
               que valgan sus mismas reglas de venta. -->
          <app-hours-dates-event class="d-none" *ngIf="directMapSession" [mapOnly]="true" [event]="event"
            [organizer]="organizer" [preselectedSession]="directMapSession"
            (mapOnlyState)="onDirectMapState($event)"></app-hours-dates-event>
        </div>
        <ng-template #divHoursDates>
          <div class="buy-slot buy-slot-hours">
            <app-hours-dates-event [pastEvent]="pastEvent" [event]="event" [organizer]="organizer"
              [preselectedSession]="preselectedSession" (closeHours)="openHoursEvent($event)"></app-hours-dates-event>
          </div>
        </ng-template>
      </div>

      <!-- La hoja blanca: todo lo que se lee. En escritorio va a dos
           columnas, para que el texto no se quede solo en medio de la página -->
      <div class="event-body">
        <div class="body-main">
        <section class="sheet-block" *ngIf="event.description || event.extra_link || event?.extra_file">
          <div class="prose" [class.is-clamped]="descriptionIsLong && !descriptionExpanded"
            [innerHTML]="event.description"></div>
          <button type="button" class="text-btn" *ngIf="descriptionIsLong" (click)="toggleDescription()">
            {{ descriptionExpanded ? 'Leer menos' : 'Leer más' }}
            <i class="fa-light" [class.fa-chevron-down]="!descriptionExpanded"
              [class.fa-chevron-up]="descriptionExpanded"></i>
          </button>

          <div class="extra-links">
            <a *ngIf="event.extra_link" class="extra-link" href="{{event?.extra_link}}" target="_blank"
              rel="noopener">
              <i class="fa-light fa-link"></i><span>{{ event?.extra_link }}</span>
            </a>
            <a *ngIf="event?.extra_file" class="extra-link" [href]="urlFiles+event.extra_file" target="_blank"
              rel="noopener">
              <i class="fa-light fa-file-lines"></i><span>Información adicional</span>
            </a>
          </div>
        </section>

        <!-- Vídeo y fotos, en un solo bloque -->
        <section class="sheet-block" *ngIf="youtubeThumbnailUrl || event?.images?.length > 0">
          <div class="youtube-player-section" *ngIf="youtubeThumbnailUrl">
            <div class="youtube-facade" *ngIf="!youtubePlayerActive" (click)="activateYoutubePlayer()">
              <img [src]="youtubeThumbnailUrl" alt="Vídeo del evento" class="youtube-thumbnail" />
              <div class="youtube-play-btn">
                <svg viewBox="0 0 68 48" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M66.5 7.7c-.8-2.9-3-5.1-5.8-5.8C55.8 0 34 0 34 0S12.2 0 7.3 1.9C4.5 2.6 2.3 4.9 1.5 7.7 0 12.8 0 24 0 24s0 11.2 1.5 16.3c.8 2.9 3 5.1 5.8 5.8C12.2 48 34 48 34 48s21.8 0 26.7-1.9c2.8-.7 5-3 5.8-5.8C68 35.2 68 24 68 24s0-11.2-1.5-16.3z"
                    fill="red" />
                  <path d="M27 34l18-10-18-10v20z" fill="white" />
                </svg>
              </div>
            </div>
            <iframe *ngIf="youtubePlayerActive" [src]="youtubeEmbedUrl" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen>
            </iframe>
          </div>
          <div class="content-swiper-img" *ngIf="event?.images?.length > 0">
            <app-swiper-images [idEvent]="event?.id" [images]="event.images"></app-swiper-images>
          </div>
        </section>

        <!-- Tótem: los botones de compra van en el cuerpo, no en una barra -->
        <div class="btns-totem" *ngIf="event.publish && viewTotem">
          <div class="container-external" *ngIf="event.only_tpv_sales || !openExternal">
            <app-btns-event-totem [event]="event" [pastEvent]="pastEvent" [repeat]="repeatEvent"
              (openHours)="openHoursEvent($event)"></app-btns-event-totem>
          </div>
        </div>

        <!-- Hashtags -->
        <div class="sheet-block" *ngIf="hashtags?.length > 0">
          <app-etiquetas *ngIf="external === true" [items]="hashtags"></app-etiquetas>
          <app-etiquetas *ngIf="external === false" [items]="event?.hashtags"></app-etiquetas>
        </div>
        </div>

        <div class="body-rail">
        <!-- Cómo llegar -->
        <section class="sheet-block" id="map" *ngIf="!viewTotem">
          <h2 class="block-label">Cómo llegar</h2>
          <div class="map-card">
            <div class="map-canvas">
              <div *ngIf="viewGoogleMap" id="maps"></div>
              <button type="button" class="map-teaser" *ngIf="!viewGoogleMap" (click)="showGoogleMap()">
                <img src="assets/img/mapa_aux.png" alt="" />
                <span class="map-teaser-label">
                  <i class="fa-light fa-map-location-dot"></i>Mostrar el mapa
                </span>
              </button>
            </div>
            <div class="map-foot">
              <div class="map-where">
                <p class="map-name" *ngIf="venueName">{{ venueName }}</p>
                <p class="map-address" *ngIf="venueAddress">{{ venueAddress }}</p>
                <p class="map-address" *ngIf="!venueName && !venueAddress">{{ event?.city?.name }}</p>
              </div>
              <a class="map-btn" *ngIf="mapsUrl" [href]="mapsUrl" target="_blank" rel="noopener">
                <i class="fa-light fa-diamond-turn-right"></i>Abrir en Maps
              </a>
            </div>
          </div>
        </section>

        <!-- Comparte -->
        <section class="sheet-block share-block" *ngIf="event.publish && !viewTotem">
          <h2 class="block-label">Comparte este evento</h2>
          <div class="share-panel" [class.has-native]="sharedSupported">
            <button type="button" class="share-copy" [class.is-copied]="linkCopied" (click)="copyEventLink()"
              [title]="linkCopied ? 'Enlace copiado' : 'Copiar enlace'">
              <i class="fa-solid" [class.fa-check]="linkCopied" [class.fa-link]="!linkCopied"></i>
              <span class="share-copy-label">{{ linkCopied ? 'Enlace copiado' : 'Copiar enlace' }}</span>
            </button>
            <button type="button" class="share-native" *ngIf="sharedSupported" (click)="shareEvent()">
              <i class="fa-light fa-arrow-up-from-bracket"></i>Compartir
            </button>
            <div class="share-networks">
              <button type="button" (click)="shareSocialEvent('whatsapp')" title="Compartir por WhatsApp">
                <i class="fa-brands fa-whatsapp"></i>
              </button>
              <button type="button" (click)="shareSocialEvent('twitter')" title="Compartir en X (Twitter)">
                <i class="fa-brands fa-x-twitter"></i>
              </button>
              <button type="button" (click)="shareSocialEvent('facebook')" title="Compartir en Facebook">
                <i class="fa-brands fa-facebook-f"></i>
              </button>
              <button type="button" (click)="shareSocialEvent('linkedin')" title="Compartir en LinkedIn">
                <i class="fa-brands fa-linkedin-in"></i>
              </button>
              <button type="button" (click)="shareSocialEvent('envelope')" title="Compartir por correo">
                <i class="fa-solid fa-envelope"></i>
              </button>
            </div>
          </div>
        </section>
        </div>
      </div>
    </div>
  </ng-template>
</div>
